import styled from 'styled-components';

interface pageWrapperProps {
	margin?: string;
	padding?: string;
	width?: string;
}
const PageWrapper = styled.div<pageWrapperProps>`
	display: inline-block;
	width: 100%;
	margin: ${({ margin }) => margin}!important;
	width: ${({ width }) => width}!important;
	padding: ${({ padding }) => padding}!important;
	position: relative;
`;
export default PageWrapper;
